export default "__VITE_ASSET__nYQsDbsn__"